import { create } from 'zustand';

export interface Toast {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message?: string;
  duration?: number;
}

interface ToastStore {
  toasts: Toast[];
  addToast: (toast: Toast) => void;
  removeToast: (id: string) => void;
  clearAllToasts: () => void;
}

export const useStore = create<ToastStore>((set) => ({
  toasts: [],
  
  addToast: (toast) => set((state) => ({
    toasts: [...state.toasts, toast],
  })),
  
  removeToast: (id) => set((state) => ({
    toasts: state.toasts.filter((toast) => toast.id !== id),
  })),
  
  clearAllToasts: () => set({ toasts: [] }),
}));